export const getStats = async ({ queryKey }) => {
  const [_key, { type, token }] = queryKey;
  // console.log('TOKEN:', token);
  let data = await fetch(`${process.env.API_URL}/stats?type=${type}`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }).then((r) => r.json());
  return data.data;
};
